import { MarkdownText } from 'components/MarkdownText'
import { ChatMessage } from 'types/chat-message'
import { AttachmentMessage, fromChatAttachment, fromUpload } from 'components/messages/AttachmentMessage'
import { ChatBubble } from 'components/messages/ChatBubble'

export type UserTextMessageProps = {
  messageItem: ChatMessage
}
export const UserMessage = ({ messageItem }: UserTextMessageProps) => {
  const { message, createdAt } = messageItem

  return (
    <div className={'tw-flex tw-flex-col tw-items-end tw-justify-end tw-gap-1.5'}>
      {messageItem.operatorAttachments?.map((att) => (
        <AttachmentMessage
          attachment={fromUpload(att)}
          key={att._id}
          align={'right'}
          borderClass={'tw-rounded-t-[20px] tw-rounded-br-[5px] tw-rounded-bl-[20px] tw-border-[0.5px]'}
        />
      ))}
      {messageItem.attachments?.map((att) => (
        <AttachmentMessage attachment={fromChatAttachment(att)} key={att._id} align={'right'} />
      ))}
      {!!message && (
        <div className="tw-flex tw-max-w-[80%] tw-flex-col tw-items-end tw-justify-end">
          <ChatBubble variant="user" timestamp={createdAt}>
            <MarkdownText text={message} />
          </ChatBubble>
        </div>
      )}
    </div>
  )
}
